import {
    AccessAutoMatching,
    AccessBayScheduling,
    AccessHaulerManagement,
    AccessPlantManagement,
    AccessProducerManagement,
    CanImpersonateUsers,
    Dashboard,
    EditSiloInvoices,
    GetFluidScheduleDetails,
    GetMilkScheduleDetails,
    ListAdmins,
    ListBactoAlert,
    ListBaseTransfers,
    ListCIPWash,
    ListDrivers,
    ListDropoffs,
    ListHaulingCompanies,
    ListInvoicing,
    ListLabReports,
    ListMonthlyReports,
    ListPickups,
    ListPickupsAndLabs,
    ListProcessors,
    ListProducers,
    ListReceivers,
    ListRouteSessions,
    ListScheduleRoutes,
    ListSharedFiles,
    ListSilos,
    ListSubAdmins,
    ListSubHauling,
    ListSubProcessors,
    ListSubProducers,
    ListTrailers,
    ListTrucks,
    ListUserGroups,
    ListUserGroupsV2,
    ManageAssignees,
    ManageCloseMonth,
    ManageCustomFields,
    ManageDeliveryReports,
    ManageHaulerAssignments,
    ManageHaulerPayReports,
    ManageHaulerRates,
    ManageHaulingCharges,
    ManageHaulingContracts,
    ManageLinkedUsers,
    ManageMilkPrices,
    ManageProcessedFluidCommodities,
    ManageProcessedFluidPickupRapidTest,
    ManageProcessedFluidsDropoffs,
    ManageProcessedFluidsPickups,
    ManageProcessedFluidsRouteSessions,
    ManageProducerPayReports,
    ManageRapidTest,
    QARapidTest,
    UploadDownload,
    ViewAccountingReports,
    ViewContracts,
    ViewDocumentation,
    ViewDriverLocations,
    ViewHaulerPayReport,
    ViewProcessedFluidsDriverLocations,
    ViewReceivingDropoffs,
    ViewProcessedFluidReceiving,
    ViewProcessedFluidReceivingRapidTest,
    ViewMilkPredictionReport,
    ViewContractPerformanceReport,
    ViewSupplyOutlookReport,
} from './permissions';
import LABELS from './constants';

const region = 'UDA';

const SubAdminManagement = {
    label: LABELS.Management,
    permissions: [
        ListAdmins,
        ListProducers,
        ListSubProducers,
        ListDrivers,
        ListProcessors(region),
        ListSubProcessors(region),
        ListHaulingCompanies(region),
        ListSubHauling(region),
        ListTrailers,
        ListTrucks,
        ListSubAdmins,
        ManageLinkedUsers,
        CanImpersonateUsers,
        // force wrap
    ],
};

const SubAdminGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListSilos,
        EditSiloInvoices,
        ViewDocumentation,
        ListUserGroups,
        ListUserGroupsV2,
        ViewDriverLocations,
        ViewProcessedFluidsDriverLocations,
        ListScheduleRoutes,
        ManageCloseMonth,
        ListPickups(),
        ManageProcessedFluidsPickups,
        ListDropoffs(),
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidPickupRapidTest,
        ListCIPWash,
        ListLabReports(),
        UploadDownload,
        ListRouteSessions(region),
        ManageProcessedFluidsRouteSessions,
        ViewProcessedFluidReceiving,
        ViewProcessedFluidReceivingRapidTest,
        ManageDeliveryReports,
        GetMilkScheduleDetails(),
        GetFluidScheduleDetails,
        QARapidTest,
        ManageRapidTest,
        ViewReceivingDropoffs,
        ListSharedFiles,
        ListInvoicing,
        AccessPlantManagement,
        AccessHaulerManagement,
        AccessAutoMatching,
        AccessProducerManagement,
        ManageProcessedFluidCommodities,
        AccessBayScheduling,
        ViewContracts,
        ManageCustomFields,
        ViewMilkPredictionReport,
        ViewContractPerformanceReport,
        ViewSupplyOutlookReport,
    ],
};

const SubAdminAccounting = {
    label: LABELS.Accounting,
    permissions: [
        ManageMilkPrices,
        ListBaseTransfers(region),
        ManageProducerPayReports,
        ViewAccountingReports,
        ManageHaulingCharges(),
        ManageHaulingContracts(),
        ManageHaulerRates,
        ManageHaulerPayReports,
        ManageAssignees,
        ManageHaulerAssignments,
        // force-wrap
    ],
};

const SubProducerManagement = {
    label: LABELS.Management,
    permissions: [ListSubProducers],
};

const SubProducerGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListPickups('View', ''),
        ListPickupsAndLabs,
        ListLabReports('View', ''),
        UploadDownload,
        ListBactoAlert(region),
        ListSharedFiles,
        AccessProducerManagement,
        // force wrap
    ],
};

const SubProducerAccounting = {
    label: LABELS.Accounting,
    permissions: [ListMonthlyReports(region)],
};

const SubProcessorManagement = {
    label: LABELS.Management,
    permissions: [ListReceivers, ListSubProcessors(region)],
};

const SubProcessorGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListSilos,
        EditSiloInvoices,
        ListDropoffs('View', ''),
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidsPickups,
        ManageProcessedFluidPickupRapidTest,
        ManageProcessedFluidsRouteSessions,
        ViewProcessedFluidReceiving,
        ListLabReports(),
        ListRouteSessions(region, 'View', ''),
        GetMilkScheduleDetails('Manage', '(View, Create Demand)'),
        GetFluidScheduleDetails,
        ViewReceivingDropoffs,
        ListSharedFiles,
        AccessPlantManagement,
        AccessBayScheduling,
        // force wrap
    ],
};

const SubHaulingManagement = {
    label: LABELS.Management,
    permissions: [ListTrailers, ListTrucks, ListSubHauling(region)],
};

const SubHaulingGeneral = {
    label: LABELS.General,
    permissions: [
        Dashboard,
        ListDrivers,
        ViewDriverLocations,
        ViewProcessedFluidsDriverLocations,
        ListPickups(),
        ManageProcessedFluidsPickups,
        ListDropoffs(),
        ManageProcessedFluidsDropoffs,
        ManageProcessedFluidPickupRapidTest,
        ManageProcessedFluidsRouteSessions,
        ListCIPWash,
        UploadDownload,
        GetMilkScheduleDetails('View', ''),
        ViewReceivingDropoffs,
        ListSharedFiles,
        ViewHaulerPayReport,
        AccessHaulerManagement,
        GetFluidScheduleDetails,
        // force wrap
    ],
};

const SubAdmin = [SubAdminManagement, SubAdminGeneral, SubAdminAccounting];
const SubProducer = [SubProducerManagement, SubProducerGeneral, SubProducerAccounting];
const SubProcessor = [SubProcessorManagement, SubProcessorGeneral];
const SubHauling = [SubHaulingManagement, SubHaulingGeneral];

const REQUIRED_PERMISSIONS = {
    Admin: [
        ListTrucks,
        ListSilos,
        ListUserGroups,
        ViewReceivingDropoffs,
        GetMilkScheduleDetails(),
        ListTrailers,
        // force-wrap
    ],
};

const UDA = {
    Admin: { permissions: SubAdmin, required: REQUIRED_PERMISSIONS.Admin },
    'Sub-Admin': { permissions: SubAdmin },
    'Sub-Producer': { permissions: SubProducer },
    Accountant: { permissions: SubProducer },
    'Feed-Provider': { permissions: SubProducer },
    Nutritionist: { permissions: SubProducer },
    'Co-Owner': { permissions: SubProducer },
    Processor: { permissions: SubProcessor },
    'Sub-Processor': { permissions: SubProcessor },
    Hauling: { permissions: SubHauling },
    'Sub-Hauling': { permissions: SubHauling },
};

export default UDA;
